import { render } from "./FormularioMedicamento.vue?vue&type=template&id=59dc49fd&scoped=true&ts=true"
import script from "./FormularioMedicamento.vue?vue&type=script&lang=ts"
export * from "./FormularioMedicamento.vue?vue&type=script&lang=ts"

import "./FormularioMedicamento.vue?vue&type=style&index=0&id=59dc49fd&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dc49fd"]])

export default __exports__